import { AccountEndpoint } from "@/views/loyalty/shared/endpoint_services/account-endpoint-service"
import { format } from "date-fns-tz"

export class AccountService {
    constructor () {
        this.accountEndpoint = new AccountEndpoint()
    }

    async createAccount (customerNumber) {
        return this.accountEndpoint.create_account(customerNumber)
    }

    async correctionAccount (account) {
        await this.accountEndpoint.correction_account(account)
    }

    async getAllCustomerAccounts () {
        return this.accountEndpoint.get_all_customer_accounts()
    }

    async getAccrualAccountActive (customerId, participantId) {
        const accounts = await this.accountEndpoint.get_accrual_account(customerId, participantId)
        return accounts.filter(f => f.campaign.status === true).map(account => {
            const date = new Date(account.campaign.createDate)
            account.campaign.createDate = format(date, "dd.MM.yyyy")
            return account
        })
        // console.log('filtered_accounts:', filtered_accounts)
        // return filtered_accounts
    }

    async getAllCampaignCustomerAccount (campaign_id, customer_number) {
        return this.accountEndpoint.get_all_campaign_customer_accounts(campaign_id, customer_number)
    }

    async getParticipantAccount (campaignId, participant_id) {
        return this.accountEndpoint.get_participant_account(campaignId, participant_id)
    }

    async getParticipantAccounts (participant_id) {
        return this.accountEndpoint.get_participant_accounts(participant_id)
    }

    async getParticipantsAccountsByCustomerAndParticipant (customer_id, participant_id) {
        return this.accountEndpoint.get_participants_accounts_by_customer_and_participant(customer_id, participant_id)
    }

    async participantCashin (campaign_id, participant_id, amount) {
        await this.accountEndpoint.participant_cashin(campaign_id, participant_id, amount)
    }

    async updateAmount (account) {
        await this.accountEndpoint.update_amount(account)
    }
}
